import { Component, ElementRef, Renderer2 } from '@angular/core'
import { MbSubmitOrderBase } from '../mb-submit-order-base'
import { MbCheckoutNavigationService } from '../../../../checkout/services/mb-checkout-navigation.service'
import { CartCheckoutService } from '../../../services/mb-cart-checkout.service'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Component({
  selector: 'mb-submit-order-cart',
  templateUrl: './mb-submit-order-cart.component.html',
  styleUrls: ['../mb-submit-order-base.scss']
})
export class MbSubmitOrderCartComponent extends MbSubmitOrderBase {

  constructor (protected activeCartService: ActiveCartService,
              protected mbCheckoutNavigationService: MbCheckoutNavigationService,
              protected elem: ElementRef,
              protected renderer: Renderer2,
              protected cartCheckoutService: CartCheckoutService) {
    super(activeCartService, elem, renderer, cartCheckoutService)
  }

  beginCheckout () {
    this.mbCheckoutNavigationService.navigateToNextCheckoutStep()
  }
}
